import React from 'react';
import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import MLIcon from '../../../MLIcon';
import CustomMuiDropdown from '../../../CustomMuiDropdown';
import { CLOSE_SIDE_PANEL } from '../../../SidePanel/store/actions';
import useSidePanel from '../../../SidePanel/hooks/useSidePanel';

import s from './SearchOptionsMenu.module.css';

function SearchOptionsMenu({
  availableSearchTypes,
  buttonLabel,
  activeIcon,
  handleSearchTypeChange,
}) {
  const { state: sidePanelState, dispatch: sidePanelDispatch } = useSidePanel();
  const {
    mediaQueries: { small },
  } = sidePanelState;
  const isSmall = useMediaQuery(`(max-width: ${small}px)`);

  const handleButtonClick = () => {
    if (sidePanelState.open) {
      sidePanelDispatch({ type: CLOSE_SIDE_PANEL });
    }
  };

  const items = availableSearchTypes.map((searchOption) => ({
    label:
      searchOption.label === 'Assignments' ? 'Assignment' : searchOption.label,
    value: searchOption.type,
    icon: searchOption.icon,
  }));

  const handleItemClick = (item) => {
    handleSearchTypeChange(item.value);
  };

  return (
    <CustomMuiDropdown
      isMenu
      items={items}
      title={buttonLabel}
      onClick={handleButtonClick}
      onClickItem={handleItemClick}
      dataTestId="search-button"
      className={classNames(s.searchOptionsMenu, {
        [s.searchOptionsMenuSmall]: isSmall,
      })}
      labelClassName={classNames({
        [s.buttonLabelSmall]: isSmall,
      })}
      buttonLeftIcon={
        <MLIcon
          type={activeIcon}
          className={classNames(s.buttonLeftIcon, {
            [s.buttonLeftIconSmall]: isSmall,
          })}
        />
      }
      buttonRightIcon={
        <MLIcon className={s.buttonRightIcon} type="caret_down" />
      }
    />
  );
}

export default SearchOptionsMenu;
